const bubble4 = (color) =>    `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 455.9 455.9" style="enable-background:new 0 0 455.9 455.9;" xml:space="preserve">
<style type="text/css">
\t.st0{fill:${color};}
\t.st1{fill:#FFFFFF;}
</style>
<circle class="st0" cx="228" cy="228" r="228"/>
<path class="st1" d="M371.6,251.9v-75.2c0-30.5-24.1-55.4-53.7-55.4H150.7c-29.6,0-53.7,24.8-53.7,55.4v75.2
\tc0,27.8,20.2,51.4,46.9,54.9l7,0.9l-25,53.6l115.7-54.1h76.4C347.5,307.2,371.6,282.4,371.6,251.9z M139.6,173.6
\tc-0.1-6.8,5.4-12.4,12.2-12.5h171.2c6.8,0.1,12.2,5.7,12.2,12.5l0,0c0.1,6.8-5.3,12.4-12.2,12.5H151.7
\tC144.9,186,139.5,180.4,139.6,173.6L139.6,173.6z M139.6,215.3c-0.1-6.8,5.4-12.4,12.2-12.5h126.6c6.8,0.1,12.2,5.7,12.2,12.5l0,0
\tc0.1,6.8-5.4,12.4-12.2,12.5H151.7C144.9,227.7,139.5,222.1,139.6,215.3L139.6,215.3z M150.7,270.7c-6.9-0.2-12.4-6-12.2-12.9
\tc0.2-6.6,5.5-12,12.2-12.2h171.2c6.9,0.2,12.4,6,12.2,12.9c-0.2,6.6-5.5,12-12.2,12.2H150.7z"/>
</svg>
`
export default bubble4;


//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble4.js
// module id = null
// module chunks = 